module.exports = __webpack_public_path__ + "static/img/03f67ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/page/livepoint/buttom.png
// module id = 654
// module chunks = 2